module.exports = __webpack_public_path__ + "img/american_credit_location.0d5a123.png";